export const counterNumber = new Array(60).fill(1).map((item, key) => item + key)